import {readonly, Ref, ref} from '@nuxtjs/composition-api';
import {useApi} from '~/composables';
import type {CustomerGroupData} from '~/modules/customer/types';
import type {UseCustomerGroupInterface, UseCustomerGroupErrors} from './useCustomerGroup';
import getCustomerGroupIdMutationGql from '~/modules/checkout/queries/getCustomerGroupIdMutation.gql';
import {Logger} from '~/helpers/logger';

export function useCustomerGroup(): UseCustomerGroupInterface {
  const {query} = useApi();
  const customerGroupIdLoading: Ref<boolean> = ref(false);
  const success: Ref<boolean> = ref(false);
  const error: Ref<UseCustomerGroupErrors> = ref({
    getCustomerGroupId: null,
  });

  const getCustomerGroupId = async (cartId: string) => {
    try {
      customerGroupIdLoading.value = true;
      const {data} = await query<CustomerGroupData>(getCustomerGroupIdMutationGql, {cartId}, { Accept: 'application/json' });
      window.localStorage.setItem('customerGroupId', data?.getCustomerGroupId?.groupId as unknown as string);
    } catch(err) {
      error.value.getCustomerGroupId = err;
      Logger.error('useCustomCart/addMultipleItems', err);
    } finally {
      customerGroupIdLoading.value = false;
    }
  }

  return {
    getCustomerGroupId,
    customerGroupIdLoading,
    error,
    success,
  };
}

export default useCustomerGroup;
